export default __webpack_public_path__ + "static/media/20.9dad1cd4.png";